/* derMarkus — Theme-Verhalten (Anfrage-Formular, Blog-Filter).
   Menü, Warenkorb, Suche bleiben Dawn-Bordmittel.
   Ohne JavaScript ist das Anfrage-Formular einfach offen. */
(function () {
  'use strict';

  function initRequestForms() {
    document.querySelectorAll('[data-request-form]').forEach(function (wrap) {
      var trigger = wrap.querySelector('[data-request-trigger]');
      if (!trigger) return;
      wrap.classList.add('is-collapsible');
      trigger.addEventListener('click', function () {
        var open = wrap.getAttribute('data-open') === 'true';
        wrap.setAttribute('data-open', open ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', String(!open));
        trigger.textContent = open ? trigger.dataset.labelClosed : trigger.dataset.labelOpen;
        if (!open) {
          var first = wrap.querySelector('.dm-form__fields input, .dm-form__fields select, .dm-form__fields textarea');
          if (first) first.focus({ preventScroll: true });
          wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
    var confirm = document.querySelector('[data-request-confirm]');
    if (confirm) confirm.scrollIntoView({ block: 'center' });
  }

  function initBlogFilter() {
    var bar = document.querySelector('[data-filterbar]');
    if (!bar) return;
    var buttons = bar.querySelectorAll('[data-filter]');
    var items = document.querySelectorAll('[data-tag]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var tag = btn.getAttribute('data-filter');
        items.forEach(function (item) {
          var tags = (item.getAttribute('data-tag') || '').split('|');
          item.hidden = !(tag === 'all' || tags.indexOf(tag) !== -1);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRequestForms();
    initBlogFilter();
  });
})();
